// extracted by mini-css-extract-plugin
export default {"noEmptyBottomSpaceWhenExpanded":"W32Go5C_omfAMo4Abwme"};